import "@/App.css";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SaveTheDate from "@/pages/SaveTheDate";
import Admin from "@/pages/Admin";
import { NAV } from "@/constants/testIds";

const Nav = () => {
  const { pathname } = useLocation();
  const onAdmin = pathname.startsWith("/admin");
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-ivory/75 border-b border-edge/60">
      <div className="max-w-6xl mx-auto px-6 md:px-10 h-14 flex items-center justify-between">
        <Link
          to="/"
          data-testid={NAV.navHome}
          className="flex items-center hover:opacity-80 transition-opacity"
          aria-label="Suvansh and Hitanksha — Home"
        >
          <img
            src="/images/monogram.jpg"
            alt="S & H monogram"
            className="h-10 w-10 rounded-full object-cover"
          />
        </Link>
        <div className="flex items-center gap-7">
          {!onAdmin && (
            <a
              href="#rsvp"
              data-testid={NAV.navRsvp}
              className="eyebrow text-navy/70 hover:text-golddeep transition-colors"
            >
              RSVP
            </a>
          )}
          {onAdmin && (
            <Link
              to="/"
              data-testid={NAV.navAdmin}
              className="eyebrow text-navy/70 hover:text-golddeep transition-colors"
            >
              Home
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Nav />
        <Toaster
          position="top-center"
          richColors={false}
          toastOptions={{
            style: {
              background: "#FBF7EE",
              border: "1px solid #E5DEC9",
              color: "#0F2447",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
        <main className="pt-14">
          <Routes>
            <Route path="/" element={<SaveTheDate />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
      </BrowserRouter>
    </div>
  );
}

export default App;
